import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue'
import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js'
import { useStateStore } from '@/stores/state.store'
import { storeToRefs } from 'pinia'
import { useDataStore } from '@/stores/data.store'
import { useShopify } from '@/stores/shopify'
import { useCart } from '@/router/cart'
import { asset_host, host } from '@/settings/settings.js'
import eventBus from '@/eventBus'
import Stats from 'three/examples/jsm/libs/stats.module'
import { useRouter, useRoute } from 'vue-router'

export function useBevRenderer() {
  //
  // Mark: CONSTANTS
  //

  let _renderContainer = useTemplateRef('container')

  const MAX_ZOOM = 4
  const MIN_FOV = 60
  const MAX_FOV = 110
  const _PI_2 = Math.PI / 2
  const _IS_TOUCH_DEVICE =
    'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0

  const MAX_MOVEMENT_ACCELERATION = 2
  const CAMERA_DAMPING = 0.9
  const ENABLE_MIRRORS = true

  const shopify = useShopify()
  const dataStore = useDataStore()
  const state = useStateStore()
  const router = useRouter()
  const route = useRoute()
  const { birdsEyeView } = storeToRefs(state)
  const { isCartOpen, closeCart } = useCart()

  const _roomSettings = ref(null)
  const _influencer = ref(null)

  const _influencerOpened = ref(false)
  
  // Function to load influencer data from Shopify API
  const loadInfluencer = async (influencerId) => {
    if (!influencerId) {
      return Promise.reject('No influencer ID provided')
    }
    
    try {
      const data = await shopify.fetchInfluencer(influencerId)
      _influencer.value = data.collection
      
      // Store influencer data in state
      if (_influencer.value) {
        state.pushRoom({
          handle: _influencer.value.handle,
          title: _influencer.value.title,
          image: _influencer.value.image.url,
          background: _influencer.value.backdrop_image?.reference?.previewImage?.url,
          color: _influencer.value.color?.value
        })
      }
      
      return Promise.resolve(_influencer.value)
    } catch (error) {
      console.error('Error loading influencer:', error)
      return Promise.reject(error)
    }
  }



  // interaction

  let _previousTouch = null
  let _previousDist = null

  let _productIsSelected = false
  let _isDragging = false



    let container = null;
    let imageViewer = null;
    let imageWrapper = null;
    let imageContainer = null;
    let image = null;
    let fullscreenBtn = null;
    let homeBtn = null;
    let zoomInBtn = null;
    let zoomOutBtn = null;
    let overlaysContainer = null;
    let seekerBox = null;
    let seekerTitle = null;
    let seekerPrice = null;
    let seekerCompareAtPrice = null;
    let seekerActualPrice = null;


    const _products = ref(null)
    const _room_id = ref(null)
    let activeOverlay = null

    // Initial state
    let scale = 1;
    let posX = 0;
    let posY = 0;
    let startPosX = 0;
    let startPosY = 0;
    let startClientX = 0;
    let startClientY = 0;
    let isDragging = false;
    let isFullscreen = false;

    // Track the minimum scale (the initial fill scale)
    let minScale = 1;

    // Track natural dimensions
    let imgNaturalWidth = 0;
    let imgNaturalHeight = 0;
        
    // Touch events for mobile devices
    let initialTouchDistance = 0;
    let initialScale = 1;
    let touchZooming = false;
    let lastTouchCenter = { x: 0, y: 0 };
    
    const initOverlays = (products) => {
        if (!products) {
            console.log('No products provided')
            return
        }
        //console.log(products)
        _products.value = products
        
        container = document.querySelector('.container');
        imageViewer = document.querySelector('.image-viewer');
        imageWrapper = document.querySelector('.image-wrapper');
        imageContainer = document.querySelector('.image-container'); 
        image = document.getElementById('viewer-image');
        fullscreenBtn = document.getElementById('fullscreen-btn');
        homeBtn = document.getElementById('home-btn');
        zoomInBtn = document.getElementById('zoom-in-btn');
        zoomOutBtn = document.getElementById('zoom-out-btn');
        overlaysContainer = document.querySelector('.overlays');
        seekerBox = document.querySelector('.seeker-box');
        seekerTitle = document.getElementById('seeker-box-title');
        seekerPrice = document.getElementById('seeker-box-price');
        seekerCompareAtPrice = document.getElementById('seeker-box-compare-at-price');
        seekerActualPrice = document.getElementById('seeker-box-actual-price');
    
        // Set initial state
        updateImageDimensions();
        imageWrapper.style.cursor = 'grab';

        // Iterate all .overlays and add event listeners
        const overlays = document.querySelectorAll('.overlay');
        overlays.forEach((overlay) => {
            addOverlayEventListeners(overlay);
        });
        addImageEventListeners();
    }


    // Helper function to hide the seeker box
    const hideSeeker = () => {
        seekerBox.classList.remove('seeker-visible');
        activeOverlay = null;
    }

    // Get image natural dimensions
    const updateImageDimensions = () => {
        if (image.complete) {
            imgNaturalWidth = image.naturalWidth;
            imgNaturalHeight = image.naturalHeight;
            fitImageToContainer();
        } else {
            image.onload = function() {
                imgNaturalWidth = image.naturalWidth;
                imgNaturalHeight = image.naturalHeight;
                fitImageToContainer();
            };
        }
    }
    
    // Fit image to container
    const fitImageToContainer = () => {
        const containerWidth = imageWrapper.clientWidth;
        const containerHeight = imageWrapper.clientHeight;
        
        // Calculate scale to fill the container completely (like object-fit: cover)
        const scaleX = containerWidth / imgNaturalWidth;
        const scaleY = containerHeight / imgNaturalHeight;
        
        // Use the larger scale to ensure image covers the container entirely
        // Add a small buffer (1.05x) to ensure there's no possibility of panning at min zoom
        minScale = Math.max(scaleX, scaleY) * 1.05;
        scale = minScale; // Reset to minimum scale
        
        // Calculate position to center the image
        posX = (containerWidth - (imgNaturalWidth * scale)) / 2;
        posY = (containerHeight - (imgNaturalHeight * scale)) / 2;

        // If window.location String includes "yana" and window.innerWidth is less than 600

        if (window.location.href.includes('yana') && window.innerWidth < 600) {
          posX = -80;
        }
        
        updateTransform();
    }
    
    // Update transform for both image and overlays
    const updateTransform = () => {
        // Apply transform to the image container instead of just the image
        imageContainer.style.width = `${imgNaturalWidth}px`;
        imageContainer.style.height = `${imgNaturalHeight}px`;
        imageContainer.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
        
        // Set the overlays container to match the image's natural dimensions
        overlaysContainer.style.width = `${imgNaturalWidth}px`;
        overlaysContainer.style.height = `${imgNaturalHeight}px`;
        
        // Apply the same transform to the overlays container
        overlaysContainer.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
        
        hideSeeker();
    }
    
    // Ensure image stays within boundaries and calculate boundaries dynamically
    const applyBoundaries = () => {
        const containerWidth = imageWrapper.clientWidth;
        const containerHeight = imageWrapper.clientHeight;
        const scaledWidth = imgNaturalWidth * scale;
        const scaledHeight = imgNaturalHeight * scale;
        
        // Calculate boundaries based on current scale
        let minX, maxX, minY, maxY;
        
        // If scaled image is smaller than container, center it
        if (scaledWidth <= containerWidth) {
            minX = maxX = (containerWidth - scaledWidth) / 2;
        } else {
            // Otherwise, constrain it to fit
            minX = containerWidth - scaledWidth;
            maxX = 0;
        }
        
        if (scaledHeight <= containerHeight) {
            minY = maxY = (containerHeight - scaledHeight) / 2;
        } else {
            minY = containerHeight - scaledHeight;
            maxY = 0;
        }
        
        // Apply constraints
        posX = Math.min(maxX, Math.max(minX, posX));
        posY = Math.min(maxY, Math.max(minY, posY));
        
        updateTransform();
    }
    
    // Function to set zoom to specific scale value
    const setZoom = (newScale, centerX, centerY) => {
        // Get center point relative to the image wrapper
        const rect = imageWrapper.getBoundingClientRect();
        const relX = centerX !== undefined ? centerX : rect.width / 2;
        const relY = centerY !== undefined ? centerY : rect.height / 2;
        
        // Calculate position on the original image
        const originalX = (relX - posX) / scale;
        const originalY = (relY - posY) / scale;
        
        // Set the new scale (bounded by min and max)
        scale = Math.min(1, Math.max(minScale, newScale));
        
        // Calculate new position to keep the same point centered
        posX = relX - originalX * scale;
        posY = relY - originalY * scale;
        
        // Apply boundaries
        applyBoundaries();
    }
    
    // Zoom at specific point
    const zoomAt = (clientX, clientY, factor) => {
        // Get mouse position relative to the image wrapper
        const rect = imageWrapper.getBoundingClientRect();
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;
        
        // Calculate position on the original image
        const originalX = (mouseX - posX) / scale;
        const originalY = (mouseY - posY) / scale;
        
        // Apply zoom factor
        const newScale = scale * factor;
        
        // Limit zoom (never smaller than the fill scale or larger than original size)
        // Don't allow zooming out smaller than needed to fill container
        if (newScale < minScale) return;
        
        // Don't allow zooming in larger than 100% of original size
        if (newScale > 1) return;
        
        // Calculate new position to keep the same point under mouse
        posX = mouseX - originalX * newScale;
        posY = mouseY - originalY * newScale;
        
        // Update scale
        scale = newScale;
        
        // Apply boundaries
        applyBoundaries();
    }
    

    const addOverlayEventListeners = (overlay) => {

        overlay.addEventListener('click', function(e) {
            showProduct(this.dataset.handle, this.dataset.shopify_id);
        })

        // Add mouse events for seeker box
        overlay.addEventListener('mouseenter', function(e) {
            const rect = this.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            
            // Position the seeker box so the overlay is centered in the left transparent half
            seekerBox.style.left = `${centerX - 45}px`; // Position so overlay is centered in left half
            seekerBox.style.top = `${centerY - 45}px`; // Half the seeker height
            
            // Update seeker content
            seekerTitle.textContent = this.dataset.tooltip;
            seekerActualPrice.textContent = this.dataset.price;
            if (this.dataset.compareatprice) {
              seekerCompareAtPrice.textContent = this.dataset.compareatprice;
              seekerActualPrice.classList.add('sale-price');
            } else {
              seekerCompareAtPrice.textContent = '';
              seekerActualPrice.classList.remove('sale-price');
            }
            //seekerPrice.textContent = this.dataset.price;
            
            // Show the seeker box
            seekerBox.classList.add('seeker-visible');
        });
        
        overlay.addEventListener('mouseleave', function() {
            seekerBox.classList.remove('seeker-visible');
        });
        
        // Add touch events for mobile
        overlay.addEventListener('touchstart', function(e) {

            // Find Seeker-Box nearest to overlay
            const currentOverlay = e.target.closest('.overlay');
            if (currentOverlay && activeOverlay == currentOverlay) {
                showProduct(currentOverlay.dataset.handle, currentOverlay.dataset.shopify_id);
                return;
            }
            activeOverlay = currentOverlay;

            e.stopPropagation(); // Prevent image pan/zoom
            e.preventDefault(); // Prevent default touch behavior
            
            const rect = this.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            
            // Position the seeker box so the overlay is centered in the left transparent half
            seekerBox.style.left = `${centerX - 45}px`; // Position so overlay is centered in left half
            seekerBox.style.top = `${centerY - 45}px`; // Half the seeker height
            
            // Update seeker content
            seekerTitle.textContent = this.dataset.tooltip;
            seekerActualPrice.textContent = this.dataset.price;
            if (this.dataset.compareatprice) {
              seekerCompareAtPrice.textContent = this.dataset.compareatprice;
              seekerActualPrice.classList.add('sale-price');
            } else {
              seekerCompareAtPrice.textContent = '';
              seekerActualPrice.classList.remove('sale-price');
            }
            
            // Show the seeker box
            seekerBox.classList.add('seeker-visible');
            
            // Set a flag to prevent immediate hiding on touchend
            this.dataset.keepSeekerVisible = "true";
            
            // Hide seeker box after 5 seconds for touch devices
            setTimeout(function() {
                seekerBox.classList.remove('seeker-visible');
                activeOverlay = null;
            }, 5000);
        });
        
        // Prevent hiding seeker immediately after touching an overlay
        overlay.addEventListener('touchend', function(e) {
            e.stopPropagation(); // Prevent image pan/zoom
            e.preventDefault(); // Prevent default touch behavior
            // Don't do anything on touchend - let the timeout handle it
        });

        overlay.style.display = 'inherit';        
    }

    const addImageEventListeners = () => {

        // Handle mouse wheel for zooming
        imageWrapper.addEventListener('wheel', function(e) {
            e.preventDefault();
            
            // Hide seeker when zooming with mouse wheel
            hideSeeker();
            
            // Determine zoom direction
            const factor = e.deltaY < 0 ? 1.1 : 0.9;
            
            zoomAt(e.clientX, e.clientY, factor);
        });

        // Mouse events for panning
        imageWrapper.addEventListener('mousedown', function(e) {
            // Only start dragging on left mouse button
            if (e.button !== 0) return;
            
            e.preventDefault();
            isDragging = true;
            startClientX = e.clientX;
            startClientY = e.clientY;
            startPosX = posX;
            startPosY = posY;
            imageWrapper.style.cursor = 'grabbing';
            
            // Hide seeker when starting to pan
            hideSeeker();
        });
        
        window.addEventListener('mousemove', function(e) {
            if (!isDragging) return;
            
            // Calculate the distance moved
            const deltaX = e.clientX - startClientX;
            const deltaY = e.clientY - startClientY;
            
            // Update position based on initial position and movement
            posX = startPosX + deltaX;
            posY = startPosY + deltaY;
            
            // Apply boundaries and update transform
            applyBoundaries();
        });
        
        window.addEventListener('mouseup', function(e) {
            if (isDragging) {
                e.preventDefault();
                isDragging = false;
                imageWrapper.style.cursor = 'grab';
            }
        });
        
        window.addEventListener('mouseleave', function() {
            if (isDragging) {
                isDragging = false;
                imageWrapper.style.cursor = 'grab';
            }
        });

        imageWrapper.addEventListener('touchstart', function(e) {
            e.preventDefault();
            
            // Don't hide seeker if touching directly on an overlay
            const target = e.target;
            if (!target.closest('.overlay')) {
                hideSeeker();
            }
            
            if (e.touches.length === 1) {
                // Single touch for panning
                isDragging = true;
                startClientX = e.touches[0].clientX;
                startClientY = e.touches[0].clientY;
                startPosX = posX;
                startPosY = posY;
            } 
            else if (e.touches.length === 2) {
                // Two touches for pinch zoom
                touchZooming = true;
                isDragging = false;
                
                // Hide seeker when pinch zooming
                hideSeeker();
                
                // Calculate initial distance between touches
                initialTouchDistance = getTouchDistance(e);
                initialScale = scale;
                
                // Store the center point between the two touches
                const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                lastTouchCenter = { x: centerX, y: centerY };
                startPosX = posX;
                startPosY = posY;
            }
        });
        
        imageWrapper.addEventListener('touchmove', function(e) {
            e.preventDefault();
            
            if (e.touches.length === 1 && isDragging) {
                // Single touch panning
                const deltaX = e.touches[0].clientX - startClientX;
                const deltaY = e.touches[0].clientY - startClientY;
                
                posX = startPosX + deltaX;
                posY = startPosY + deltaY;
                
                applyBoundaries();
            } 
            else if (e.touches.length === 2 && touchZooming) {
                // Calculate current touch center point
                const currentCenterX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                const currentCenterY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                
                // Calculate center point movement (for panning during zoom)
                const centerDeltaX = currentCenterX - lastTouchCenter.x;
                const centerDeltaY = currentCenterY - lastTouchCenter.y;
                
                // Calculate current distance for zoom
                const currentDistance = getTouchDistance(e);
                const touchFactor = currentDistance / initialTouchDistance;
                
                // Calculate new scale but don't apply it yet
                const newScale = Math.min(1, Math.max(minScale, initialScale * touchFactor));
                
                // Get wrapper rect for calculations
                const rect = imageWrapper.getBoundingClientRect();
                const relX = currentCenterX - rect.left;
                const relY = currentCenterY - rect.top;
                
                // Calculate position on the original image
                const originalX = (relX - posX) / scale;
                const originalY = (relY - posY) / scale;
                
                // Apply zoom
                scale = newScale;
                
                // Apply new position that combines:
                // 1. Zoom centering + 2. Touch center point movement (pan)
                posX = relX - originalX * scale + centerDeltaX;
                posY = relY - originalY * scale + centerDeltaY;
                
                // Update last touch center for next move
                lastTouchCenter = { x: currentCenterX, y: currentCenterY };
                
                // Apply boundaries
                applyBoundaries();
            }
        });
        
        imageWrapper.addEventListener('touchend', function(e) {
            if (e.touches.length === 0) {
                isDragging = false;
                touchZooming = false;
            } else if (e.touches.length === 1) {
                touchZooming = false;
                
                // Reset for potential panning
                startClientX = e.touches[0].clientX;
                startClientY = e.touches[0].clientY;
                startPosX = posX;
                startPosY = posY;
                isDragging = true;
            }
        });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', function() {
            // Debounce resize event
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                fitImageToContainer();
            }, 200);
        });
    
    }

    // Helpers
    const getTouchDistance = (e) => {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    const showProduct = (handle, shopifyId) => {
        const product = {
            handle: handle,
            shopifyId: shopifyId
        };
        router.push({ path: route.fullPath, query: { product: product.handle } })
        state.setProduct(product)
    }




  const productSelected = (product) => {
    if (product) {
      if (isCartOpen()) {
        closeCart()
      }
      router.push({ path: route.fullPath, query: { product: product.handle } })
      state.setProduct(product)
    }
  }

  const selectProductByHandle = (handle) => {
    const product = _productInformation.value.find((p) => p.handle === handle )
    if (product) {
      productSelected(product)
      trackEvent('select_product_by_handle', handle);
    }
  }




  //
  // EVENT HANDLERS
  //

  const onTouchend = () => {
    // console.log('Touch End');

    _previousTouch = null
    _previousDist = null

    if (_isDragging) {
      _isDragging = false

      // if (birdsEyeView.value === true) {
      //   console.log(camera.value.position.x)
      // }

      return
    }
  }

  const onMouseUp = (event) => {
    // console.log('Mouse Up')
    if (_isDragging) {
      _isDragging = false
      return
    }
  }

  const onMouseMove = (event) => {
    _isDragging = event.buttons === 1 && event.button === 0
  }

  const onTouchMove = (event) => {
    //hideSeeker()
    if (!_isDragging) {
      _isDragging = true

      //hideIndicator()
    }

    //cameraContols(event)
  }

  const onWheel = (event) => {
    //const step = birdsEyeView.value === true ? 0.1 : 0.05
    /*
    let newZoom = event.deltaY > 0 ? _manualZoomFactor + step : _manualZoomFactor - step
    _manualZoomFactor = Math.max(0, Math.min(1.0, newZoom))

    _camera.zoom = getMinZoom() + _manualZoomFactor * (getMaxZoom() - getMinZoom())
    _camera.updateProjectionMatrix()
    */
  }

  const onToggleBev = (value) => {
    if (value == state.birdsEyeView) {
      return
    }

    //hideIndicator()
  }

  //
  // Controls
  //


  onMounted(() => {
    /*
    _app = document.getElementById('app')

    eventBus.$on('product-panel-closed', deselectProduct)
    eventBus.$on('toggleBev', onToggleBev)
    eventBus.$on('cart-added-items', () => {
      _productIsSelected = false
    })

    _renderContainer.value.addEventListener('mouseup', onMouseUp)
    _renderContainer.value.addEventListener('mousemove', onMouseMove)
    _renderContainer.value.addEventListener('touchmove', onTouchMove)
    _renderContainer.value.addEventListener('wheel', onWheel)
    _renderContainer.value.addEventListener('touchend', onTouchend)
    _renderContainer.value.addEventListener('mouseleave', onTouchend)
    document.addEventListener('gesturestart', disablePinchToZoom)
    document.addEventListener('gesturechange', disablePinchToZoom)
    document.addEventListener('gestureend', disablePinchToZoom)
    
    window.addEventListener('resize', resize, false)
    */
  })

  onBeforeUnmount(() => {
    //freeMemory()
/*
    eventBus.$off('toggleBev')
    eventBus.$off('product-panel-closed')
    eventBus.$off('cart-added-items')

    _renderContainer.value.removeEventListener('mouseup', onMouseUp)
    _renderContainer.value.removeEventListener('mousemove', onMouseMove)
    _renderContainer.value.removeEventListener('touchmove', onTouchMove)
    _renderContainer.value.removeEventListener('wheel', onWheel)
    _renderContainer.value.removeEventListener('touchend', onTouchend)
    _renderContainer.value.removeEventListener('mouseleave', onTouchend)

    document.removeEventListener('gesturestart', disablePinchToZoom)
    document.removeEventListener('gesturechange', disablePinchToZoom)
    document.removeEventListener('gestureend', disablePinchToZoom)

    window.removeEventListener('resize', resize)
    */
  })

  return {
    initOverlays,
    showProduct,
    loadInfluencer,
    _influencer,
    _influencerOpened
  }
}
